import { FolderOpenDot } from 'lucide-react'
import { useState } from 'react'

import ComboboxMultiSelectFilter, {
  type ComboboxFilterOption,
} from '../../reusable/table/ComboboxMultiSelectFilter'
import { type MultipleSelectedValuesFilter } from '../types'
import FilterManagementDropdown from './FilterManagementDropdown'
import { filterByLabelAndValueCallback } from './utils'

const StatusFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  const statusOptions: ComboboxFilterOption<string>[] = [
    { label: 'Active', value: 'active' },
    { label: 'Silenced', value: 'silenced' },
    { label: 'Resolved', value: 'resolved' },
  ]

  const filteredOptions = statusOptions?.filter(
    filterByLabelAndValueCallback(query)
  )

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        options={[{ groupLabel: 'Status', options: filteredOptions || [] }]}
        placeholder='Search statuses to filter...'
        onValueChange={setQuery}
      >
        <FilterManagementDropdown
          {...props}
          options={statusOptions || []}
          noSelectionText='Status'
          pluralIdentifier='statuses'
        >
          <FolderOpenDot size={20} />
        </FilterManagementDropdown>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default StatusFilter
